// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3GphE","buttons":"RemoveExpirationActionButtons_buttons__3SCai"};